import { render, staticRenderFns } from "./articlemanageadd.vue?vue&type=template&id=061feff0&scoped=true&"
import script from "./articlemanageadd.vue?vue&type=script&lang=js&"
export * from "./articlemanageadd.vue?vue&type=script&lang=js&"
import style0 from "./articlemanageadd.vue?vue&type=style&index=0&id=061feff0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061feff0",
  null
  
)

component.options.__file = "articlemanageadd.vue"
export default component.exports